module.exports = __webpack_public_path__ + "img/chico_padel_bono.865d39de.png";